export default __webpack_public_path__ + "b6ddf3323bfad628f9f23d1e7b98fb3b.jpeg";